Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.SECONDS = (function () {

    function SECONDS (field, entity) {

        Greenmile.PanelBuilder.Fields.ComplexField.apply(this, arguments);

    };

    return SECONDS;

}());